import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import Info_Fall from '../../component/Fall/Info_Fall';

const ChoYunYeong = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);


    const openTitle = "조윤영❤️이승호";
    const openDesc = "2025년 6월14일 토요일 12:00PM";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/134/thumb.jpg";

    const lng = 126.998523144915;
    const lat = 37.6041320110277;

    const placeTelNum = "02-941-1142";


    const forCar = "서울 성북구 정릉로 10길 127\n\n1. 제 1주차장(르한스) 주차발렛서비스\n2. 제 1주차장 만차 시, 제 2주차장(LG물류센터, 국민대) \n이용가능\n** 제 2주차장 이용 시 셔틀버스 상시운행";
    const forShuttleBus = "한성대입구역 6번출구 50M앞 마을버스 정류장 \n (스텝 인솔) / 배차간격 : 20분 \n(11:00 / 11:20 / 11:40 / 12:00)";
    const forPublic = "1. 4호선 한성대 입구역 6번 출구 → \n택시 승차 : 성북동 → 길상사 지나서 정릉방향 / 6-10분 \n소요\n\n2. 4호선 길음역 3번 출구 → 버스 승차: 국민대 방향 \n[청덕초교] 하차 후 / 북악산길 방면 도보 이동 15분 소요\n(길음역 3번출구 연계 버스: 171,163, 1213, 7211)";
    
    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 와인
        concept: "SUMMER",
        titleColor: "#5b0100",
        pointColor: "#5b0100",
        btnBgColor: "#5b0100",
        fontColor: "#fff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
}

    const title = "윤영, 승호 결혼합니다";

    const msg1 = "두 사람이\n한 사람보다 나음은\n저희가 수고함으로 \n좋은 상을 얻을 것임이라";
    const msg2 = "전도서4:9"


    const groomAccountList = [
        {
            role: "신랑",
            name: "이승호",
            bank: "신한은행",
            accountNumber : "110-333-437140",
            isKakao : false
        },
        {
            role: "신랑 부",
            name: "이명원",
            bank: "농협은행",
            accountNumber : "891-12-241521",
            isKakao : false
        },
        {
            role: "신랑 모",
            name: "송은정",
            bank: "농협은행",
            accountNumber : "841133 -52-035901",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "조윤영",
            bank: "국민은행",
            accountNumber : "066-21-0818-366",
            isKakao :false
        }
        ,{
            role: "신부 부",
            name: "조병학",
            bank: "새마을금고",
            accountNumber : "1039-09-0043902",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "최형숙",
            bank: "우리은행",
            accountNumber : "1002-834-700686",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "눈못마주침",
            brideAnswer: "뒷꿈치포기"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "아직잘모름",
            brideAnswer: "청심환어디?"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "항상웃어줘",
            brideAnswer: "넌내전부야"
        },
        // {
        //     question : "유부남/녀 기념 각오 한마디!",
        //     groomAnswer: "행복 그잡채",
        //     brideAnswer: "늘 지금처럼"
        // },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "고맙습니다",
            brideAnswer: "행복할게요"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이승호",
            call: "010-6504-2711"
        }
        ,
        {
            role: "신랑 부",
            name: "이명원",
            call: "010-3584-6149"
        },
        {
            role: "신랑 모",
            name: "송은정",
            call: "010-2588-6149"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "조윤영",
            call: "010-4109-3665"
        }
        ,{
            role: "신부 부",
            name: "조병학",
            call: "010-3035-8809"
        }
        ,{
            role: "신부 모",
            name: "최형숙",
            call: "010-4320-8809"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };


        // #582F13
        // #423866
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#5b0100"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Summer weddingData={weddingData} color={"#ffffff"} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} letteringFontColor={"#5b0100"} dateColor={"#ffffff"} bottom={"85%"} bottom2={"75%"} dateBottom={"1%"} top={"2%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <Information conceptStyle={conceptStyle} informationList={informationList} />
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc forPublic={forPublic} forShuttleBus={forShuttleBus} forCar={forCar} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ChoYunYeong;